import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import MenuSidebar from "@/components/settings/menu-sidebar";
import AdminGuard from "@/components/auth/admin-guard";
import { usePermissionsContext } from "@/components/context/permissions-provider";
import { SITE_EDITOR_PATH, useSettingsMenuHidden } from "@/components/sites/editor/editor-layout-state";
import { useIsFullscreen } from "@/components/context/fullscreen-context";

/** El editor de colecciones (`/settings/collections`, sin subrutas). */
const COLLECTIONS_EDITOR = /^\/settings\/collections\/?$/;

export const Route = createFileRoute("/_authenticated/settings/_layout")({
  component: SettingsLayout,
});

function SettingsLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { can, isLoading } = usePermissionsContext();
  // En el editor de un sitio el menú se puede ocultar (botón de su barra).
  const [menuHidden] = useSettingsMenuHidden();
  // En pantalla completa queda solo el contenido de la sección, a todo el
  // ancho: también se oculta el menú de Configuración (vuelve al salir).
  const isFullscreen = useIsFullscreen();
  const hideMenu = isFullscreen || (menuHidden && SITE_EDITOR_PATH.test(pathname));
  // Quien no configura colecciones (no puede ver y editar su configuración)
  // abre el editor solo para sus colecciones privadas: sin el menú de
  // secciones de Configuración, aunque tenga acceso a alguna. El guard de la
  // ruta decide si entra.
  const configuresCollections = can("read", "custom_fields") && can("update", "custom_fields");
  if (!isLoading && COLLECTIONS_EDITOR.test(pathname) && (!can("read", "settings") || !configuresCollections)) {
    return (
      <div className="relative flex flex-1 flex-col min-h-0 min-w-0 overflow-x-hidden md:overflow-y-auto">
        <Outlet />
      </div>
    );
  }
  return (
    <AdminGuard module="settings" requiredAction="read">
      <div className="flex flex-col md:flex-row md:flex-1 md:min-h-0 gap-2">
        {!hideMenu && <MenuSidebar />}
        {/* `relative`: los elementos absolutos sin ancestro posicionado (p. ej. el
            input oculto que Radix agrega a cada Switch dentro de un form) se
            ubicaban respecto de la pagina y no de este contenedor con scroll:
            estiraban el documento y aparecia un segundo scroll que desplazaba
            todo el layout (pagina de una conexion MQTT, "Publicar un mensaje"). */}
        <div className="relative flex-1 flex flex-col min-h-0 min-w-0 overflow-x-hidden md:overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </AdminGuard>
  );
}
